import { render } from "./LargeHeadlineInformationalLayout.vue?vue&type=template&id=7f7e89c4&scoped=true&ts=true"
import script from "./LargeHeadlineInformationalLayout.vue?vue&type=script&lang=ts"
export * from "./LargeHeadlineInformationalLayout.vue?vue&type=script&lang=ts"

import "./LargeHeadlineInformationalLayout.vue?vue&type=style&index=0&id=7f7e89c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7e89c4"]])

export default __exports__